import { db } from "../../firebase/firebase";
import { collection, query, where, getDocs, writeBatch } from "firebase/firestore";

const updateMessagesStatus = async (sender: string, recipient: string) => {
  try {
    const messagesRef = collection(db, "messages");

    const queryMessage = query(
      messagesRef,
      where("recipient", "==", recipient),
      where("sender", "==", sender),  
      where("status", "==", "unread")
    );
    const querySnapshot = await getDocs(queryMessage);
    if (querySnapshot.empty) return; 

    const batch = writeBatch(db);
    querySnapshot.forEach((doc) => {
      batch.update(doc.ref, { status: "read" });
    });

    await batch.commit();
  } catch (error) {
    console.error("Error updating messages status:", error);
  }
};

export default updateMessagesStatus;
